module.exports = __webpack_public_path__ + "static/img/mail success.2aa66f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail success.png
// module id = qSZM
// module chunks = 15